import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavParams } from '@ionic/angular';
import { CoreProvider } from 'src/app/services/core';
import FileSaver from 'file-saver';

@Component({
  selector: 'page-pdf-viewer',
  templateUrl: 'pdf-viewer.html',
  styleUrls: ['pdf-viewer.scss']
})
export class PdfViewerPage {
  title = "Informe Generado";
  pdfurl: string = '';
  blob: Blob;

  constructor(public core: CoreProvider, public navParams: NavParams, public sanitizer: DomSanitizer) {
    let title = this.navParams.get('title');
    if (title) this.title = title;
    if (!this.navParams.get('data')) {
      this.dismiss();
    } else {
      this.blob = PdfViewerPage.b64toBlob(this.navParams.get('data'), "application/pdf", 512);
      this.pdfurl = window.URL.createObjectURL(this.blob);
    }
  }

  public static b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  public dismiss() {
    this.core.modalCtrl.dismiss();
  }

  public download() {FileSaver.saveAs(this.blob, "PDF Report.pdf");};

}
